import { exists } from "../runtime";

export interface AmoNotification {
  id: number;
  title: string;
  body: string;
  description?: string;
  isRead: 0 | 1;
  type: string;
  date_sent: string;
}

export function AmoNotificationFromJSON(json: any): AmoNotification {
  return AmoNotificationFromJSONTyped(json);
}

export function AmoNotificationFromJSONTyped(json: any): AmoNotification {
  if ((json === undefined) || (json === null)) {
      return json;
  }
  return {
      
      'id': !exists(json, 'id') ? undefined : json['id'],
      'title': !exists(json, 'title') ? undefined : json['title'],
      'body': !exists(json, 'body') ? undefined : json['body'],
      'description': !exists(json, 'description') ? undefined : json['description'],
      'isRead': !exists(json, 'isRead') ? undefined : json['isRead'],
      'type': !exists(json, 'type') ? undefined : json['type'],
      'date_sent': !exists(json, 'date_sent') ? undefined : json['date_sent'],
  };
}

export function AmoNotificationToJSON(value?: AmoNotification | null): any {
  if (value === undefined) {
      return undefined;
  }
  if (value === null) {
      return null;
  }
  return {
      'id': value.id,
      'title': value.title,
      'body': value.body,
      'description': value.description,
      'isRead': value.isRead,
      'type': value.type,
      'date_sent': value.date_sent,
  };
}
